import { env } from '$lib/config/environment';
import { ReportingService } from './service';
import { ReportingServiceSentry } from './service_sentry';
import { ReportingServiceMock } from './service_mock';

let reportingInstance: ReportingService | null = null;

export function createReportingService(): ReportingService {
  if (reportingInstance) {
    return reportingInstance;
  }

  if (env.features.mockServices || !env.features.errorReporting) {
    reportingInstance = new ReportingServiceMock();
  } else {
    reportingInstance = new ReportingServiceSentry();
  }

  return reportingInstance;
}

export { ReportingService } from './service';
export type { ReportingService as IReportingService };
